import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material//dialog';
import { NextcloudFile } from 'src/app/classes';

@Component({
  selector: 'app-onlyoffice-dialog',
  templateUrl: './onlyoffice-dialog.component.html',
  styleUrls: ['./onlyoffice-dialog.component.css']
})
export class OnlyofficeDialogComponent implements OnInit {

  file: NextcloudFile;

  constructor(
    @Inject(MAT_DIALOG_DATA) private _data: OnlyofficeDialogComponentData,
    private _dialogRef: MatDialogRef<OnlyofficeDialogComponent>
  ) {
    this.file = _data.file;
  }

  close(){
    this._dialogRef.close();
  }

  ngOnInit(): void {
  }

}

export class OnlyofficeDialogComponentData {
  file: NextcloudFile;
}
